
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Thanks from "../pages/thanks/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/thanks",
    element: <Thanks />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
